<template>
  <!-- 附件 -->
  <div class="Minister-top annexFile" ref="annexFile">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">附件</div>
    </div>

    <div class="information_content">
      <el-button type="primary" @click="addFile" v-if="system == 5 && !isChakan"
        >添加附件</el-button
      >

      <div class="fileList" v-if="fileList && fileList.length > 0">
        <div
          class="fileItem"
          v-for="(item, index) in fileList"
          :key="index + 'file'"
        >
          <el-tag size="small" :type="getTypeName(item.type, index).type">{{
            getTypeName(item.type, index).name
          }}</el-tag>
          <span>{{ item.file.name }}</span>
          <i
            v-if="system == 5 && !isChakan"
            class="el-icon-delete"
            style="color: #f56c6c; cursor: pointer"
            @click="removeFile(index)"
          ></i>
        </div>
      </div>
    </div>

    <el-dialog
      ref="addFile"
      v-loading="saveDisabled"
      element-loading-text="上传中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      width="555px"
      title="添加附件"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      append-to-body
      @close="close"
    >
      <div class="content" ref="content">
        <el-form
          ref="form"
          :model="form"
          :rules="formRules"
          label-width="100px"
        >
          <el-form-item label="附件类型:" prop="type">
            <el-select v-model="form.type" clearable>
              <el-option
                v-for="(item, index) in annexTypeList"
                :key="index + 'type'"
                :label="item.title"
                :value="item.value"
              ></el-option>
            </el-select>

            <span v-if="form.type" class="tips" style="margin-left: 8px"
              >允许的媒体类型：{{ currentType.accept1 }}</span
            >
          </el-form-item>
          <el-form-item label="上传附件:" prop="file" v-if="form.type">
            <el-upload
              ref="upload"
              :accept="currentType.accept"
              :action="uploadApi"
              :headers="customHeaders"
              :http-request="customRequest"
              :file-list="form.file"
            >
              <el-button :disabled="!form.type">上传附件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Baseurl } from "../../../api/api/api";
import Axios from "axios";
export default {
  name: "annexFile",
  props: {
    isChakan: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      uploadApi: Baseurl + "allegroImage/createAndUploadOfferAttachments",
      visible: false,
      sellerId: "",

      annexTypeList: [
        {
          title: "指南",
          value: "MANUAL",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "特价条款",
          value: "SPECIAL_OFFER_RULES",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "比赛条款",
          value: "COMPETITION_RULES",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "图书摘录",
          value: "BOOK_EXCERPT",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "手册",
          value: "USER_MANUAL",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "安装手册",
          value: "INSTALLATION_INSTRUCTIONS",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "游戏手册",
          value: "GAME_INSTRUCTIONS",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "能源标签",
          value: "ENERGY_LABEL",
          accept: "image/jpeg,image/jpg,image/png",
          accept1: "JPEG，JPG，PNG",
        },
        {
          title: "产品信息表",
          value: "PRODUCT_INFORMATION_SHEET",
          accept: "application/pdf",
          accept1: "PDF",
        },
        {
          title: "轮胎标签",
          value: "TIRE_LABEL",
          accept: "image/jpeg,image/jpg,image/png",
          accept1: "JPEG，JPG，PNG",
        },
        {
          title: "安全信息手册",
          value: "SAFETY_INFORMATION_MANUAL",
          accept: "application/pdf",
          accept1: "PDF",
        },
      ], //附件类型
      form: {
        type: undefined,
        file: [],
      },
      formRules: {
        type: { required: true, message: "请选择附件类型", trigger: "change" },
        file: { required: true, message: "请选择附件类型", trigger: "change" },
      },
      fileList: [],

      saveDisabled: false,
      colors: ["success", "", "warning", "danger"],
    };
  },
  methods: {
    initData() {
      this.fileList = [];
      this.close();
    },
    setSellerId(val) {
      this.sellerId = val;
    },
    getTypeName(val, index) {
      const i = index % 4;
      return {
        name: this.annexTypeList?.find((ele) => ele.value === val)?.title,
        type: this.colors[i],
      };
    },

    addFile() {
      if (!this.sellerId) {
        this.$message.warning("请先选择店铺,再添加附件!");
        return;
      }
      this.visible = true;
    },
    removeFile(index) {
      this.fileList?.splice(index, 1);
    },

    customRequest({ file }) {
      const API =
        Baseurl +
        `allegroImage/createAndUploadOfferAttachments?sellerId=${this.sellerId}&type=${this.form.type}`;
      const formData = new FormData();
      formData.append("file", file);

      const loading = this.$loading({
        target: this.$refs.addFile.$el,
        text: "上传中...",
        background: "rgba(218,218,238,0.2)",
      });
      Axios({
        url: API,
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.form.file = [file];
            this.fileList.push(res.data.data);
            this.close();
          }
          this.form.file = [];
          loading.close();
        })
        .catch(() => {
          this.form.file = [];
          loading.close();
        });
    },

    close() {
      this.visible = false;
      Object.assign(this.form, {
        type: undefined,
        file: undefined,
      });
      this.$refs.form && this.$refs.form.resetFields();
    },
  },
  computed: {
    customHeaders() {
      return {
        token: localStorage.getItem("token"),
      };
    },
    currentType() {
      return (
        this.annexTypeList?.find((ele) => ele.value === this.form.type) || {}
      );
    },
  },
};
</script>

<style scoped lang="scss">
div.annexFile {
  .information_content {
    padding-left: 80px;
  }

  div.fileList {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
    margin-bottom: 16px;
    div.fileItem {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  }
}
/deep/ .el-select .el-input .el-select__caret {
  width: 25px;
  line-height: 42px;
}
</style>
